import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rl-counter-button',
  templateUrl: './counter-button.component.html',
  styleUrls: ['./counter-button.component.scss']
})
export class CounterButtonComponent{

  @Input() text : string;
  @Input() counter : number;
  @Input() total : number = 1;
  @Input() hideBar : boolean;
  @Output() onClick = new EventEmitter<void>();

}
